export const TEST_ID = 'flightPlannerPanelHeader';

export const DISCARD_TEST_ID = 'flightPlannerPanelHeaderDiscard';

export const SAVE_TEST_ID = 'saveFlightPlanButton';
